function headerSCroll() {
	window.addEventListener("scroll", function () {
		if (window.pageYOffset > 0 && $(window).width() >= 1200) {
			document.querySelector("header").classList.add("header-scroll");
		} else {
			document.querySelector("header").classList.remove("header-scroll");
		}
	});
}

function search_Active() {
	$("header .search-icon").on("click", function () {
		$(".search-overlay").addClass("active");
		$("body").addClass("disable");
	});
	$(document).on("click", function (event) {
		var $trigger = $("header");
		var $trigger_2 = $(".searchbox");
		if (
			$trigger !== event.target &&
			!$trigger.has(event.target).length &&
			$trigger_2 !== event.target &&
			!$trigger_2.has(event.target).length
		) {
			$(".search-overlay").removeClass("active");
			$("body").removeClass("disable");
		}
	});
}

function mappingMenu() {
	var leftMenu = $("header .left-menu ul li");
	var rightMenu = $("header .right-menu ul li");
	var rightSide = $("header .right-side .hotline");
	var navMobile = $("header .nav-mobile");
	leftMenu.mapping({
		mobileWrapper: "header .nav-mobile nav ul",
		mobileMethod: "appendTo",
		desktopWrapper: "header .left-menu ul",
		desktopMethod: "appendTo",
		breakpoint: 1280,
	});
	rightMenu.mapping({
		mobileWrapper: "header .nav-mobile nav ul",
		mobileMethod: "appendTo",
		desktopWrapper: "header .right-menu ul",
		desktopMethod: "appendTo",
		breakpoint: 1280,
	});
	rightSide.mapping({
		mobileWrapper: "header .nav-mobile",
		mobileMethod: "appendTo",
		desktopWrapper: "header .right-side",
		desktopMethod: "appendTo",
		breakpoint: 459.9,
	});
}

function navSlide() {
	var close = $(".nav-mobile .close-button em");
	var burgur = $(".burger");
	var mobile = $(".nav-mobile");
	var overlay = $("#overlay");
	burgur.on("click", function () {
		mobile.toggleClass("active");
		overlay.toggleClass("active");
		$(this).toggleClass("active");
		$("body").toggleClass("disabled");
	});
	overlay.on("click", function () {
		mobile.removeClass("active");
		$(this).removeClass("active");
		$("body").removeClass("disabled");
		burgur.removeClass("active");
	});
	close.on("click", function () {
		mobile.removeClass("active");
		$("body").removeClass("disabled");
		burgur.removeClass("active");
		overlay.removeClass("active");
	});
}

function checkLayoutBanner() {
	var pagesBanner = $("#page-banner");
	var heightHeader = $("header").outerHeight();
	var mainBanner = $("#main-banner");
	if (!$("body").hasClass("homepage")) {
		if (mainBanner.length >= 1) {
			$("main").css("padding-top", heightHeader);
		} else if (pagesBanner.length >= 1) {
			$("main").css("padding-top", heightHeader);
		} else {
			$("main").css("padding-top", heightHeader);
		}
		$(".pages-news-detail .box-right").css("top", heightHeader);
	}
}

function modal() {
	var modal = $("#modal");
	var btnModal = $("#show-modal");
	var clsModal = $("#modal-close");
	btnModal.on("click", function () {
		modal.addClass("active");
		$("html").css("overflow", "hidden");
	});
	clsModal.on("click", function () {
		modal.removeClass("active");
		$("html").css("overflow", "visible");
	});
}

function swiperInit() {
	var main_banner = new Swiper("#main-banner .swiper-container", {
		spaceBetween: 0,
		centeredSlides: true,
		parallax: true,
		autoplay: {
			delay: 4500,
		},
		speed: 1120,
		observer: true,
		observeParents: true,
	});
	var index_4 = new Swiper(".section.index-4 .swiper-container", {
		speed: 500,
		watchSlidesVisibility: true,
		watchSlidesProgress: true,
		observer: true,
		observeParents: true,
		autoplay: false,
		slidesPerColumnFill: "row",
		// loop: true,
		breakpoints: {
			320: {
				slidesPerView: 2,
				slidesPerColumn: 2,
				slidesPerGroup: 2,
				spaceBetween: 10,
			},
		},
		navigation: {
			prevEl: ".section.index-4 .swiper-button-prev",
			nextEl: ".section.index-4 .swiper-button-next",
		},
	});
	var index_5 = new Swiper(".swiper-news .swiper-container", {
		speed: 300,
		freeMode: false,
		watchSlidesVisibility: true,
		watchSlidesProgress: true,
		observer: true,
		observeParents: true,
		autoplay: false,
		// loop: true,
		breakpoints: {
			320: {
				slidesPerView: 1,
				spaceBetween: 15,
			},
			425: {
				slidesPerView: 2,
				spaceBetween: 15,
			},
			768: {
				slidesPerView: 3,
				spaceBetween: 30,
			},
			1280: {
				spaceBetween: 30,
				slidesPerView: 4,
			},
		},
		navigation: {
			prevEl: ".swiper-news .swiper-button-prev",
			nextEl: ".swiper-news .swiper-button-next",
		},
	});
	var capa_2 = new Swiper(".swiper-capa-2 .swiper-container", {
		speed: 300,
		freeMode: false,
		watchSlidesVisibility: true,
		watchSlidesProgress: true,
		observer: true,
		observeParents: true,
		autoplay: false,
		// loop: true,
		breakpoints: {
			320: {
				slidesPerView: 1,
				spaceBetween: 15,
			},
			425: {
				slidesPerView: 2,
				spaceBetween: 15,
			},
			768: {
				slidesPerView: 3,
				spaceBetween: 30,
			},
			1280: {
				spaceBetween: 30,
				slidesPerView: 3,
			},
		},
		navigation: {
			prevEl: ".swiper-capa-2 .swiper-button-prev",
			nextEl: ".swiper-capa-2 .swiper-button-next",
		},
	});
	var capa_3 = new Swiper(".swiper-capa-3 .swiper-container", {
		speed: 300,
		freeMode: false,
		watchSlidesVisibility: true,
		watchSlidesProgress: true,
		observer: true,
		observeParents: true,
		autoplay: false,
		// loop: true,
		breakpoints: {
			320: {
				slidesPerView: 1,
				spaceBetween: 15,
			},
			425: {
				slidesPerView: 2,
				spaceBetween: 15,
			},
			768: {
				slidesPerView: 3,
				spaceBetween: 30,
			},
			1280: {
				spaceBetween: 30,
				slidesPerView: 4,
			},
		},
		navigation: {
			prevEl: ".swiper-capa-3 .swiper-button-prev",
			nextEl: ".swiper-capa-3 .swiper-button-next",
		},
	});
	var capa_6 = new Swiper(".swiper-capa-6 .swiper-container", {
		speed: 300,
		freeMode: false,
		watchSlidesVisibility: true,
		watchSlidesProgress: true,
		observer: true,
		observeParents: true,
		autoplay: false,
		spaceBetween: 30,
		slidesPerView: 1,
		navigation: {
			prevEl: ".swiper-capa-6 .swiper-button-prev",
			nextEl: ".swiper-capa-6 .swiper-button-next",
		},
	});
	var about_3 = new Swiper(".swiper-about-3 .swiper-container", {
		speed: 300,
		freeMode: false,
		watchSlidesVisibility: true,
		watchSlidesProgress: true,
		observer: true,
		observeParents: true,
		autoplay: false,
		breakpoints: {
			320: {
				slidesPerView: 1,
				spaceBetween: 15,
			},
			425: {
				slidesPerView: 2,
				spaceBetween: 15,
			},
			768: {
				slidesPerView: 3,
				spaceBetween: 30,
			},
			1280: {
				spaceBetween: 30,
				slidesPerView: 3,
			},
		},
		navigation: {
			prevEl: ".swiper-about-3 .swiper-button-prev",
			nextEl: ".swiper-about-3 .swiper-button-next",
		},
	});
	var swiper_product_other = new Swiper(
		".swiper-product-other .swiper-container",
		{
			speed: 300,
			freeMode: false,
			watchSlidesVisibility: true,
			watchSlidesProgress: true,
			observer: true,
			observeParents: true,
			autoplay: false,
			breakpoints: {
				320: {
					slidesPerView: 1,
					spaceBetween: 15,
				},
				425: {
					slidesPerView: 2,
					spaceBetween: 15,
				},
				768: {
					slidesPerView: 3,
					spaceBetween: 30,
				},
				1280: {
					spaceBetween: 30,
					slidesPerView: 3,
				},
			},
			navigation: {
				prevEl: ".swiper-product-other .swiper-button-prev",
				nextEl: ".swiper-product-other .swiper-button-next",
			},
		}
	);
	//Product
	var product_detail_thumbs = new Swiper(
		".swiper-product-detail .gallery-thumbs",
		{
			freeMode: true,
			watchSlidesVisibility: true,
			watchSlidesProgress: true,
			navigation: {
				nextEl: ".swiper-product-detail .swiper-button-next",
				prevEl: ".swiper-product-detail .swiper-button-prev",
			},
			breakpoints: {
				320: {
					slidesPerView: 2,
				},
				768: {
					slidesPerView: 4,
					spaceBetween: 10,
				},
				1280: {
					spaceBetween: 13,
					slidesPerView: 4,
				},
			},
		}
	);
	var product_detail_top = new Swiper(".swiper-product-detail .gallery-top", {
		spaceBetween: 10,
		thumbs: {
			swiper: product_detail_thumbs,
		},
	});
}

function setBackgroundElement() {
	$("[setBackground]").each(function () {
		var background = $(this).attr("setBackground");
		var bgMobile = $(this).attr("setBackgroundMobile");
		var breakpoint = $(this).attr("breakpoint");
		if (typeof bgMobile != "undefined") {
			if ($(window).width() <= breakpoint) {
				$(this).css({
					"background-size": "cover",
					"background-position": "center center",
					"background-image": "url(" + bgMobile + ")",
				});
			} else {
				$(this).css({
					"background-size": "cover",
					"background-position": "center center",
					"background-image": "url(" + background + ")",
				});
			}
		} else {
			$(this).css({
				"background-size": "cover",
				"background-position": "center center",
				"background-image": "url(" + background + ")",
			});
		}
	});
	$("[setBackgroundRepeat]").each(function () {
		var background = $(this).attr("setBackgroundRepeat");
		$(this).css({
			"background-image": "url(" + background + ")",
			"background-repeat": "repeat",
		});
	});
}

function showBackToTop() {
	var heightTop =
		$("header").outerHeight() + $("#main-banner").outerHeight() + 100;
	var heightPageTop =
		$("header").outerHeight() + $("#page-banner").outerHeight() + 100;
	$(window).scroll(function () {
		if (
			$(this).scrollTop() > heightTop ||
			$(this).scrollTop() > heightPageTop
		) {
			$("#back-to-top").addClass("active");
		} else {
			$("#back-to-top").removeClass("active");
		}
	});

	$("#back-to-top").on("click", function (e) {
		e.preventDefault();
		$("html,body").animate(
			{
				scrollTop: 0,
			},
			800
		);
	});
}

function scrollToTab() {
	$(".tab-panel ul").scrollTo($(".tab-panel ul li.active"), 100);
}

function filterCate() {
	setTimeout(() => {
		var header = $("header").outerHeight() - 10;
		$(".filter_tool").css("top", header);
	}, 100);

	var item = $(".product-sidebar");
	var filter = $(".filter_tool");
	var main = $(".filter_tool .main");
	var close = $(".filter_tool .close-button");
	$(main).on("click", function () {
		filter.addClass("active");
		item.addClass("active");
	});
	$(close).on("click", function () {
		filter.removeClass("active");
		item.removeClass("active");
	});
}

function checkBoxAddItem() {
	$(".pages-product-detail-1 .add-item .wrapper").on("click", function () {
		$(this).toggleClass("active");
	});
}

function tabActive() {
	$(".tab-navigation li a").on("click", function () {
		$(this).parents(".tab-navigation").find("li").removeClass("active");
		$(this).parents("li").addClass("active");

		var display = $(this).attr("data-type");
		console.log(this);
		$(".tab-item").removeClass("active");
		$("#" + display).addClass("active");
		let maxHeight = 400;
		let contentTab = $(".tab-wrapper .tab-item.active");
		if (contentTab.height() < maxHeight) {
			$(contentTab).find(".readmore").hide();
		} else {
			$(contentTab).find(".readmore").show();
		}
	});
	$(".readmore a").on("click", function () {
		var $content = $(".fullcontent");
		$content.toggleClass("active");
	});
}

function tabLarge() {
	$(".capa-2 .primary-tab ul li a").on("click", function () {
		var contentTab = $(this).attr("data-type");
		$(".swiper-capa-2").removeClass("active");
		$(this).parent().addClass("active").siblings().removeClass("active");
		$("#" + contentTab).addClass("active");
	});
}

function tab2Section() {
	$(".capa-4 ul li a").on("click", function () {
		$(this).parent().addClass("active").siblings().removeClass("active");
		var bigContent = $(this).attr("data-type");
		$(".big-item").removeClass("active");
		$("#" + bigContent).addClass("active");
	});
}

function tabIndex() {
	$(".index-3 .tab-link li a").on("click", function () {
		$(this).parent().addClass("active").siblings().removeClass("active");
		var bigContent_2 = $(this).attr("data-type");
		$(".big-box").removeClass("active");
		$("#" + bigContent_2).addClass("active");
	});
}

function moveForm() {
	let form = $(".box-info-contact");
	let placeForm = $(".infor-inner");
	form.appendTo(placeForm);
}

function changeInput() {
	let input = $(".index-6 .frm-btn input[type= 'submit']");
	$("html").attr("lang") == "vi"
		? input.attr("value", "ĐĂNG KÝ")
		: input.attr("value", "Register");
}

function capa7() {
	let parent = $(".capa-7");
	$(".capa-7 a").on("click", function (e) {
		e.preventDefault();
		parent.toggleClass("active");
	});
}

function ZoomImg() {
	var zoom = $(".zoom-img .img");
	var w_og = $(
		".swiper-product-detail .block-top .swiper-slide img"
	).outerWidth();
	var h_og = $(
		".swiper-product-detail .block-top .swiper-slide img"
	).outerHeight();
	var w_wt = $(".wrap-table").outerWidth();
	var h_wt = $(".wrap-table").outerHeight();
	var scale = 1;
	var zoom_w_h = $(".zoom-img").css({ width: w_wt, height: h_wt });
	var mouse = $(".swiper-product-detail .block-top .swiper-slide");
	mouse.on("mousemove", function (e) {
		zoom.parent(".zoom-img").addClass("active");
		zoom.css(
			"background-image",
			" url(" + $(this).find("img").attr("src") + ")"
		);
		var x = ((-1 * ($(this).offset().left - e.pageX)) / w_og) * 100.0;
		var y = ((-1 * ($(this).offset().top - e.pageY)) / h_og) * 100.0;
		zoom.css({
			"background-position-x": x + "%",
			"background-position-y": y + "%",
			transform: "scale(" + scale + ")",
		});
		$(".zoom-cursor").addClass("active");
		$(".zoom-cursor .zoom-area").css({
			left: x + "%",
			top: y + "%",
		});
	});
	mouse.on("mouseleave", function () {
		zoom.parent(".zoom-img").removeClass("active");
		$(".zoom-cursor").removeClass("active");
	});
}

function fancyboxSetting() {
	$(".info-option .btn[data-fancybox]").fancybox({
		parentEl: "form",
	});
	$("[data-fancybox='popup']").fancybox({
		parentEl: "form",
	});
	$(".fancy-gallery").fancybox({
		parentEl: "body",
		backFocus: false,
		beforeLoad: function () {
			$(".page-product .ajaxresponse").addClass("remove-ajaxresponse");
			$(".page-product .ajaxresponse").removeClass("ajaxresponse");
		},
		afterClose: function () {
			setTimeout(() => {
				$(".page-product .remove-ajaxresponse").addClass(
					"ajaxresponse"
				);
				$(".page-product .ajaxresponse").removeClass(
					"remove-ajaxresponse"
				);
			}, 50);
		},
	});
}

function activeCommonNav() {
	var customWidth;
	var ww = $(window);
	ww >= 576 ? (customWidth = 40) : (customWidth = 20);
	$(".primary-tab li").each(function () {
		if ($(this).hasClass("active")) {
			$(this)
				.closest("ul")
				.scrollLeft($(this).position().left - customWidth);
		}
	});
}

const checkClickInside = (element) => {
	$(document).on("click", function (e) {
		if (!$(element).is(e.target) && $(element).has(e.target).length === 0) {
			$(element).removeClass("clickInside");
		} else {
			$(element).addClass("clickInside");
		}
	});
};

function expandItem() {
	// Filter Load
	var hasLoadBtn = $("[has-expand-btn]");
	hasLoadBtn.each(function () {
		var $this = $(this);
		var expandBtn = $(this).find(".expand-btn");
		var list = $(this).find(".expand-item").length;
		var count;
		var countMobile = $(this).attr("item-count-mobile");
		countMobile != undefined && countMobile != 0 && ww < 576
			? (count = Number($(this).attr("item-count-mobile")))
			: (count = Number($(this).attr("item-count")));
		var expand = Number($(this).attr("item-expand"));

		//=// Init
		function init(initValue, thisFunction) {
			if (list >= initValue) {
				thisFunction
					.find(".expand-item")
					.slice(0, initValue)
					.slideDown({
						complete: function () {
							$(this).addClass("done-animated");
						},
					});
			} else {
				thisFunction.find(".expand-item").slideDown();
				thisFunction.find(".expand-item").addClass("done-animated");
			}
			if (list == 0 || list <= initValue) {
				expandBtn.hide();
			}
		}
		init(count, $this);

		// Click
		function expandBtnInit(initCount, thisFunction) {
			count = initCount + expand <= list ? initCount + expand : list;
			thisFunction
				.closest(hasLoadBtn)
				.find(".expand-item")
				.slice(0, count)
				.slideDown({
					complete: function () {
						$(this).addClass("done-animated");
					},
				});
			// console.log(count);
			if (count == list) {
				thisFunction.slideUp();
			}
		}
		expandBtn.on("click", function (e) {
			e.preventDefault();
			expandBtnInit(count, $(this));
		});
	});
}

const autoAppend = () => {
	var appendId = $("[id*='autoAppend-']");
	appendId.each(function (e) {
		var id = $(this).attr("id").slice(11);
		// console.log(id);
		$(this).appendTo("[id*='autoAppendHere-" + id + "']");
		var curHeight = $(this).get(0).scrollHeight;
	});
};

$(document).ready(function () {
	// Header
	headerSCroll();
	search_Active();
	mappingMenu();
	// Menu Mobile
	navSlide();
	// Padding Fix -5ed
	checkLayoutBanner();
	// Main Banner
	swiperInit();
	// Background Set
	setBackgroundElement();
	// Show Back to Top
	showBackToTop();
	// Scroll To Acive
	scrollToTab();
	// Product list
	filterCate();
	// Product Detail
	ZoomImg();
	tabActive();
	modal();
	tabLarge();
	tab2Section();
	moveForm();
	tabIndex();
	changeInput();
	capa7();
	fancyboxSetting();
	activeCommonNav();
	expandItem();
	autoAppend();
});
